import { ICampaignServer } from "model/campaigns";
import { ILineitem } from "model/lineitems/lineitem";
import { DefaultNetwork } from "./options";

export const MAX_LINEITEMS_WITH_DEFAULT_ID = 19;
export const MIN_DEFAULT_ID = 81;
export const AVAILABLE_IDS: number[] = Array(MAX_LINEITEMS_WITH_DEFAULT_ID)
  .fill(MIN_DEFAULT_ID)
  .map((v, index) => v + index);
export type IDefaultCampaignIdRange =
  | "81"
  | "82"
  | "83"
  | "84"
  | "85"
  | "86"
  | "87"
  | "88"
  | "89"
  | "90"
  | "91"
  | "92"
  | "93"
  | "94"
  | "95"
  | "96"
  | "97"
  | "98"
  | "99";

export function getIdsUsedAcrossSameApp(
  sameAppCampaigns: ICampaignServer[] = []
) {
  const usedIds = new Set<IDefaultCampaignIdRange>();
  sameAppCampaigns.forEach((camp) => {
    camp.lineitems?.forEach((li: ILineitem) => {
      if (li.skAdNetworkConfiguration?.defaultCampaignId) {
        usedIds.add(li.skAdNetworkConfiguration?.defaultCampaignId);
      }
    });
  });
  return [...usedIds];
}

export type UsedInDetail = {
  camapignId: string;
  campaignName: string;
  lineitemId: string;
  lineitemName: string;
  defaultNetwork?: DefaultNetwork;
  running?: boolean;
};
export function getIdsUsedAcrossSameAppWithDetails(
  sameAppCampaigns: ICampaignServer[] = [],
  lineitemRunningMap?: Record<string, boolean>
) {
  const usedIds: {
    [key in IDefaultCampaignIdRange]?: Array<UsedInDetail>;
  } = {};
  sameAppCampaigns.forEach((camp) => {
    camp.lineitems?.forEach((li: ILineitem) => {
      if (li.skAdNetworkConfiguration?.defaultCampaignId) {
        if (!usedIds[li.skAdNetworkConfiguration.defaultCampaignId]) {
          usedIds[li.skAdNetworkConfiguration.defaultCampaignId] = [];
        }
        (
          usedIds[
            li.skAdNetworkConfiguration.defaultCampaignId
          ] as UsedInDetail[]
        ).push({
          camapignId: camp.id,
          campaignName: camp.name,
          lineitemId: li.id,
          lineitemName: li.name,
          defaultNetwork: li.skAdNetworkConfiguration?.defaultNetworkId,
          running: lineitemRunningMap?.[li.id],
        });
      }
    });
  });
  return usedIds;
}
